var map = {
	"./blog-1.jsx": [
		8933,
		933
	],
	"./blog-2.jsx": [
		9566,
		566
	],
	"./blog-3.jsx": [
		5259,
		259
	],
	"./blog-4.jsx": [
		7012,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9996;
module.exports = webpackAsyncContext;